const MESH_DECIMATION = [
  {
    text: 'Atlas Baking',
    value: 'rebake',
    description: 'Aggregates all UVs and creates a unified layout, bakes all information to new UVs.',
  },
  {
    text: 'Preserve Tiling',
    value: 'preserveTiling',
    description:
      'Preserves input\'s tiled UVs and textures. Non-tiling UVs will be aggregated and baked as in "Atlas Baking" mode. If ao is enabled will be baked into a new 2nd UV set.',
  },
  {
    text: 'Preserve Mesh & Material Nodes',
    value: 'rebakePreserveNodes',
    description:
      'Preserves all mesh and material nodes. Aggregates all UVs per material and bakes information to these new UVs. Can lead to a high number of output texture maps and draw calls!',
  },
  {
    text: 'Preserve UVs',
    value: 'preserveUVsAndNodes',
    description:
      'Preserves all mesh, material nodes and all input UVs. Process might stop and deliver slightly higher mesh resolution if face or vertices target is very low.',
  },
  {
    text: 'Drop Textures to Material Colors',
    value: 'dropTextures',
    description:
      'Averages the color of input texture maps and converts to material colors. Avoids baking and textures. Results in very low file size, but might produce more draw calls than "Atlas Baking".',
  },
  {
    text: 'Remeshing (Keep Alpha)',
    value: 'remeshing-keep-alpha',
    description: '',
  },
  {
    text: 'Remeshing (Bake Alpha)',
    value: 'remeshing-bake-alpha',
    description: '',
  },
];

export const getSimplificationMethodLabel = (mesh: string | undefined) => {
  return MESH_DECIMATION.find((m) => m.value === mesh)?.text || 'Unknown';
};
